module.exports = __webpack_public_path__ + "media/images/secure-d3e3d2b9a19bf8189bbe18dbbf6a249c.jpg";